var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tasks",staticClass:"tasks dragscroll"},[_vm._l((_vm.tasks),function(task){return [(_vm.showCompleted(task, _vm.showHiddenTasks))?_c('task',{key:task.id,attrs:{"task":task,"data-id":task.id}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }